import React, { useState, useMemo } from 'react';
import SEO from '../../Components/SEO';
import StoreHeader from './component/StoreHeader';
import FilterBar from './component/FilterBar';
import ProductGrid from './component/ProductGrid';
import CartDrawer from './component/CartDrawer';
import CartButton from './component/CartButton';
import useCart from './hooks/useCart';
import products from './data/products.json';

const sortProducts = (items, sort) => {
    const arr = [...items];
    if (sort === 'price-asc') return arr.sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') return arr.sort((a, b) => b.price - a.price);
    if (sort === 'rating') return arr.sort((a, b) => b.rating - a.rating);
    return arr;
};

const Boutique = () => {
    const [category, setCategory] = useState('all');
    const [sort, setSort] = useState('default');
    const [cartOpen, setCartOpen] = useState(false);

    const { cart, cartCount, addToCart, removeFromCart, updateQty } = useCart();

    const filtered = useMemo(() => {
        const base =
            category === 'all'
                ? products
                : products.filter((p) => p.category === category);
        return sortProducts(base, sort);
    }, [category, sort]);

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-store-black text-slate-900 dark:text-white transition-colors duration-300">
            <SEO
                title="Boutique — Safaridew | Gadgets & Tech Intelligents"
                description="Découvrez nos gadgets futuristes : étuis PC, masques respiratoires, lampes intelligentes et bien plus. Livraison gratuite."
                canonical="https://safaridew.vercel.app/Boutique"
            />

            {/* Store header with title */}
            <StoreHeader />

            {/* Sticky filter bar */}
            <FilterBar
                activeCategory={category}
                onCategoryChange={setCategory}
                sortValue={sort}
                onSortChange={setSort}
                total={filtered.length}
            />

            {/* Product grid */}
            <ProductGrid products={filtered} onAddToCart={addToCart} />

            {/* Cart drawer */}
            <CartDrawer
                isOpen={cartOpen}
                onClose={() => setCartOpen(false)}
                cart={cart}
                onRemove={removeFromCart}
                onUpdateQty={updateQty}
            />

            {/* Floating Cart Button */}
            <CartButton cartCount={cartCount} onCartOpen={() => setCartOpen(true)} />
        </div>
    );
};

export default Boutique;
